<template>
    <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0 text-dark">All Lots</h1>
                    </div><!-- /.col -->
                    <div class="col-sm-6">
                        <router-link to="/lot-create" class="btn btn-info float-right"><i class="fas fa-plus-circle"></i> LOT Create</router-link>
                        <img id="logoId" src="../../../public/images/logo.png" style="width:40px; height:40px; display:none;">
                    </div><!-- /.col -->
                </div><!-- /.row -->
            </div><!-- /.container-fluid -->
        </div>
        <!-- /.content-header -->
        <!-- Main content -->
        <section class="content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="row">
                                    <div v-if="authUser.role_id != 7" class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <label for="title">{{ $t('globalTrans.hub') }}</label>
                                            <v-select name="hub_id"
                                                v-model="search.hub_id"
                                                label="text"
                                                :reduce="item => item.id"
                                                :options= hubList
                                                :placeholder="$t('globalTrans.select')"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <label for="title">Status</label>
                                            <v-select name="hub_id"
                                                v-model="search.status"
                                                label="text"
                                                :reduce="item => item.id"
                                                :options= lotStatusList
                                                :placeholder="$t('globalTrans.select')"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <label for="date">Start Date</label>
                                            <input type="date" id="date" v-model="search.start_date" class="form-control" />
                                        </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <label for="date">End Date</label>
                                            <input type="date" id="date" v-model="search.end_date" class="form-control" />
                                        </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <button class="btn btn-info btn-sm" type="submit" @click.prevent="searchData" style="margin-top:28px;"><i class="fa fa-search"></i></button>
                                            <button class="btn btn-warning btn-sm ml-1" @click.prevent="reload" style="margin-top:28px;"><i class="fa fa-sync-alt"></i></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <b-overlay :show="loader">
                                    <div class="table-responsive">
                                        <table class="table table-bordered table-striped table-sm">
                                            <thead>
                                                <tr>
                                                    <th>SL</th>
                                                    <th>Consignment ID</th>
                                                    <th>Date</th>
                                                    <th>Total Order</th>
                                                    <th>Destination Hub</th>
                                                    <th>Security Code</th>
                                                    <th>Status</th>
                                                    <th>Created By</th>
                                                    <th>Updated By</th>
                                                    <th style="text-align:center;">Action</th>
                                                </tr>
                                            </thead>
                                            <tfoot>
                                                <tr>
                                                    <th>SL</th>
                                                    <th>Consignment ID</th>
                                                    <th>Date</th>
                                                    <th>Total Order</th>
                                                    <th>Destination Hub</th>
                                                    <th>Security Code</th>
                                                    <th>Status</th>
                                                    <th>Created By</th>
                                                    <th>Updated By</th>
                                                    <th style="text-align:center;">Action</th>
                                                </tr>
                                            </tfoot>
                                            <tbody>
                                                <tr v-for="(item, index) in listData" :key="index">
                                                    <td>{{ index+1 }}</td>
                                                    <td>
                                                        {{ item.consignment_id }}
                                                        <i
                                                            class="fa fa-copy"
                                                            style="margin-left: 8px; cursor: pointer; color: #555;"
                                                            @click="copyToClipboard(item.consignment_id)"
                                                            title="Copy Consignment ID"
                                                        ></i>
                                                    </td>
                                                    <td>{{ item.date | dateformat }}</td>
                                                    <td>{{ item.total_order }}</td>
                                                    <td>{{ item.hub ? item.hub.name : '' }}</td>
                                                    <td>{{ item.security_code }}</td>
                                                    <td><span :class="'return-status-'+ item.status">{{ getStatus(item.status) }}</span></td>
                                                    <td>{{ item.createdby ? item.createdby.name : '' }}</td>
                                                    <td>{{ item.updatedby ? item.updatedby.name : '' }}</td>
                                                    <td style="text-align:center;">
                                                        <button class="btn btn-primary btn-sm" @click="lotDetails(item.id)" title="Show Order"> <i class="fa fa-eye"></i> </button>  
                                                        <!-- <button class="btn btn-success btn-sm"  @click="downloadPdf(item.id)" title="PDF"><i class="fa fa-download" aria-hidden="true"></i></button>  -->
                                                        <button class="btn btn-warning btn-sm ml-1" type="button" @click.prevent="excelDownload(item.id)" title="Excel">
                                                            <i class="fa fa-download"></i>
                                                        </button>
                                                        <button class="btn btn-secondary btn-sm ml-1" @click="printLabel" title="Label">
                                                            <i class="fa fa-print"></i>
                                                        </button>  
                                                        <a v-if="item.status == 2" class="btn btn-success btn-sm ml-1" href="/order-process" title="Process">
                                                            <i class="fa fa-exchange-alt"></i>
                                                        </a>   
                                                        <button v-if="(item.status == 1 || item.status == 4) && authUser.role_id != 6" class="btn btn-info btn-sm ml-1" @click="showStatusUpdate(item)" title="Receive"> <i class="fa fa-check"></i> </button>                                                        
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>  
                                    </div>
                                    <div class="mt-3">
                                        <b-pagination
                                            v-model="pagination.currentPage"
                                            :per-page="pagination.perPage"
                                            :total-rows="pagination.totalRows"
                                            @input="searchData"
                                        />
                                    </div>
                                </b-overlay>
                            </div>
                        </div>
                    </div>
                </div>
            </div><!-- /.container-fluid -->
        </section>
        <div v-if="statusModal" class="modal fade show" style="display:block" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <b-overlay :show="loader">
                    <form v-on:keyup.enter="updatePickup">
                        <b-overlay :show="loader">
                            <div class="modal-content">
                                <div class="modal-header bg-info text-white">
                                    <h5 class="modal-title text-center w-100">LOT status update</h5>
                                    <button type="button" class="close" aria-label="Close" @click="cancelModal">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                                        <form @submit.prevent="handleSubmit(updateLot)">
                                            <div class="row">
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                    <ValidationProvider name="Total Order" vid="total_order" v-slot="{errors}" rules="required">
                                                        <div class="form-group">
                                                            <label for="total_order">Total Order</label>
                                                            <input type="text" id="total_order" v-model="form_edit.total_order" readonly="1" class="form-control" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');">
                                                            <span class="text-danger">{{ errors[0] }}</span>
                                                        </div> 
                                                    </ValidationProvider>                         
                                                </div> 
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                    <ValidationProvider name="Hub Received" vid="consignment_id" v-slot="{errors}" rules="required">
                                                        <div class="form-group">
                                                            <label for="consignment_id">Consignment ID<span class="text-danger" title="Required">*</span></label>
                                                            <input type="text" id="consignment_id" v-model="form_edit.consignment_id" class="form-control" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');">
                                                            <span class="text-danger">{{ errors[0] }}</span>
                                                        </div> 
                                                    </ValidationProvider>                         
                                                </div> 
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                    <ValidationProvider name="Current Status" vid="consignment_id" v-slot="{errors}" rules="required">
                                                        <div class="form-group">
                                                            <label for="current_status">Current Status</label>
                                                            <input type="text" id="current_status" :value="getStatus(form_edit.status)" readonly="1" class="form-control">
                                                            <span class="text-danger">{{ errors[0] }}</span>
                                                        </div> 
                                                    </ValidationProvider>                         
                                                </div> 
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                    <ValidationProvider name="Time" vid="time" v-slot="{errors}" rules="required">
                                                        <div class="form-group">
                                                            <label for="time">Status <span class="text-danger" title="Required">*</span></label>
                                                            <v-select name="time"
                                                                style=""
                                                                v-model="form_edit.new_status"
                                                                label="text"
                                                                :reduce="item => item.id"
                                                                :options= lotEditStatusList
                                                                :placeholder="$t('globalTrans.select')"
                                                            />
                                                            <span class="text-danger">{{ errors[0] }}</span>
                                                        </div>  
                                                    </ValidationProvider>                      
                                                </div>
                                            </div>
                                        </form>
                                    </ValidationObserver>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-info" @click.prevent="updateLot">{{ $t('globalTrans.submit') }}</button>
                                    <button type="button" class="btn btn-danger" @click="cancelModal">{{ $t('globalTrans.cancel') }}</button>
                                </div>
                            </div>
                        </b-overlay>
                    </form>
                </b-overlay>
            </div>
        </div>
    </div>
</template>
<script>
    import config from '@/config'
    import moment from 'moment'
    import 'jspdf-autotable';
    import ExportPdf from './DetailsPdf'
    import Label from './Label.js'
    export default {
        name:'lot',
        data(){
            return {   
                loader: false,   
                statusModal: false,          
                search: {
                    merchant_id: '',
                    hub_id: '',
                    amount: '',
                    start_date : moment().subtract(7,'d').format('YYYY-MM-DD'),
                    end_date   : moment().format('YYYY-MM-DD')
                },
                key:'',
                form_edit: '',
                lotEditStatusList: [],
                errors:[],
                pagination: {
                    currentPage: 1,
                    totalRows: 0,
                    perPage: this.$store.state.commonObj.perPage,
                    slOffset: 1
                }
            }
        },
        created(){
            this.loadData()
        },
        watch: {
            stateReload : function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.loadData()
                }
            }
        },
        computed : {
            stateReload () {
                return this.$store.state.stateReload
            },
            listData () {
                return this.$store.state.list
            },
            hubList: function () {
                return this.$store.state.commonObj.hubList
            },
            authUser () {
                return this.$store.state.authUser
            },
            lotStatusList () {
                return this.$store.state.lotStatusList
            }
        },
        methods:{
            copyToClipboard(text) {
                navigator.clipboard.writeText(text)
                // .then(() => {
                //     // Optional: show a success message
                //     this.$toast?.success('Copied to clipboard!') || alert('Copied!');
                // })
                // .catch(err => {
                //     console.error('Failed to copy text: ', err);
                // });
            },
            async excelDownload (id) {
                this.loader = true
                try {
                    const response = await config.getFile('excel-download/lot-details/' + id)
                    const url = window.URL.createObjectURL(new Blob([response.data]))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'LotDetails-' + id + '.csv')
                    document.body.appendChild(link)
                    link.click()
                    link.remove()
                    window.URL.revokeObjectURL(url)
                } catch (error) {
                    this.$toast.error({
                        title: 'Error',
                        message: 'Sorry, something went wrong',
                        color: '#dc3545'
                    })
                }
                this.loader = false
            },
            printLabel() {
                const base64Logo = this.getBase64Logo(document.getElementById('logoId'))
                Label.exportLabelDetails(base64Logo, this.printorders)
            },
            reload () {
                this.search = Object.assign({}, {
                    merchant_id: '',
                    hub_id: '',
                    amount: '',
                    start_date : moment().subtract(10,'d').format('YYYY-MM-DD'),
                    end_date   : moment().format('YYYY-MM-DD')
                })
            },
            showStatusUpdate(itemDetails) {
                this.getLotEditStatusList(itemDetails.status)
                this.form_edit = Object.assign(itemDetails, { new_status: '' })
                this.statusModal = true
            },
            async updateLot(){
                this.loader = true
                const response = await config.postData('/lot/update', this.form_edit)                
                this.loader = false
                if (response.success) {
                    this.statusModal = false;    
                    this.$toast.success({
                        title: 'Success',
                        message: 'Lot status updated successfully',
                        color: '#218838'
                    })
                } else {
                    this.$refs.form.setErrors(response.errors)
                    this.$toast.error({
                        title: 'Error',
                        message: 'Sorry, something went wrong',
                        color: '#dc3545'
                    })
                }
                this.loadData();
            },
            getLotEditStatusList (currentStatus) {
                if(currentStatus == 1) {
                    this.lotEditStatusList = this.$store.state.lotStatusList.filter(el => el.id == 2)
                } else if(currentStatus == 2) {
                    this.lotEditStatusList = this.$store.state.lotStatusList.filter(el => el.id == 3)
                } else if(currentStatus == 4) {
                    this.lotEditStatusList = this.$store.state.lotStatusList.filter(el => el.id == 5)
                }
                   
            },
            searchData () {
                this.loadData()
            },
            async loadData(){    
                this.loader = true 
                const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })       
                const response = await config.getData('/lot/list', params)
                this.loader = false
                if (response.success){
                    this.$store.dispatch('setList', response.data.data)
                    this.paginationData(response.data)
                } else {
                    this.$store.dispatch('setList', [])
                } 
            },
            paginationData (data) {
                this.pagination.currentPage = data.current_page
                this.pagination.totalRows = data.total
                this.pagination.perPage = data.per_page
                this.pagination.slOffset = this.pagination.perPage * this.pagination.currentPage - this.pagination.perPage + 1
            },
            lotDetails (id) {
                const url = this.$router.resolve({ name: 'lot.details', query: { id: id} }).href;
                window.open(url, '_blank');
            },
            cancelModal(){
                this.statusModal = false;
                document.body.classList.remove("modal-open");
            },
            getStatus (status) {
                const getStatus = this.lotStatusList.find(el => el.id == status)
                return getStatus.text ?? '';
            },
            async downloadPdf(itemId){
                this.loader = true
                const response = await config.getData(`/return/details/${itemId}`)
                this.loader = false
                if (response.success) {
                    this.pdfDownload(response.data, response.merchant, response.rider)   
                } else {                
                    this.$toast.error('Sorry, something went wrong')  
                }
            },
            pdfDownload(datas, merchant, rider) {
                // this.loader = true
                const base64Logo = this.getBase64Logo(document.getElementById('logoId'))
                ExportPdf.returnPdfDetails(base64Logo, datas, merchant, rider)
                // this.loader = false
            },
            getBase64Logo (logo) {
                var canvas = document.createElement('canvas')
                canvas.width = logo.width
                canvas.height = logo.height
                var ctx = canvas.getContext('2d')
                ctx.drawImage(logo, 0, 0)
                var dataURL = canvas.toDataURL('image/png')
                return dataURL.replace(/^data:image\/(png|jpg);base64,/, '')
            },
            async returnReceive (id) {
                this.loader = true
                this.$store.dispatch('stateReload', true)
                const response = await config.getData(`/return/merchant-receive/${id}`)                
                this.loader = false
                if (response.success) {  
                    this.$toast.success({
                        title: 'Success',
                        message: response.message,
                        color: '#218838'
                    })
                } else {
                    this.$toast.error({
                        title: 'Error',
                        message: response.message,
                        color: '#dc3545'
                    })
                }
                this.$store.dispatch('stateReload', false)  
            }
        }
    }
</script>
